import { render, staticRenderFns } from "./step_6.vue?vue&type=template&id=168da13c&scoped=true&lang=pug&"
import script from "./step_6.vue?vue&type=script&lang=js&"
export * from "./step_6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168da13c",
  null
  
)

export default component.exports